export default __webpack_public_path__ + "1994f9ca2be95db28aa4e04b63cf7618.svg";